import { Component, AfterViewInit,Inject,ViewChild } from '@angular/core';
import {MatPaginator, MatSort} from '@angular/material';
import { DataUserService } from '../../../Services/data-user.service';

import {MatDialog, MatDialogRef,MAT_DIALOG_DATA} from '@angular/material';
import {HttpClient} from '@angular/common/http';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { DataApiService } from 'src/app/Services/data-api.service';

export interface DialogData {
  id_root: number;
}
@Component({
  selector: 'app-ver-usuarios-secundarios',
  templateUrl: './ver-usuarios-secundarios.component.html',
  styleUrls: ['./ver-usuarios-secundarios.component.scss']
})
export class VerUsuariosSecundariosComponent implements AfterViewInit {

  constructor(
    private http: HttpClient,    
    private DataUser:DataUserService,
    private dialog: MatDialog,
    private dataApi:DataApiService,
    public dialogRef: MatDialogRef<VerUsuariosSecundariosComponent>,
    @Inject(MAT_DIALOG_DATA) public data2: DialogData 
  ) { }

  exampleDatabase: ExampleHttpDatabase | null;
  data: GithubIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  itemPerPage = 8;
  idUser = this.data2.id_root;

  displayedColumns: string[] = [
    'id', 
    'name_surname' ,
    'area',
    'email',
    'telefonos'   
  ];
  
  public error = null;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngAfterViewInit() {
    this.exampleDatabase = new ExampleHttpDatabase(this.http,this.dataApi);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.exampleDatabase!.getRepoIssues(
            this.idUser,this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);   
  }

}

export interface GithubApi {
  items: GithubIssue[];
  total_count: number;
}

export interface GithubIssue {
  id:number,
  name:string,
  surname:string,
  area:string,
  email:string,
  telefono1:string,
  telefono2:string  
}

/** An example database that the data source uses to retrieve data for the table. */
export class ExampleHttpDatabase{
  constructor(private http: HttpClient,
    private dataApi : DataApiService) {}

  getRepoIssues(idUser:number,sort: string, order: string, page: number): Observable<GithubApi> {     
    const href = this.dataApi.url;
    const requestUrl =
        `${href}/verUsuarioSecundarios/${page + 1}/8/${idUser}`;

    return this.http.get<GithubApi>(requestUrl);
  } 
  
}

